module.exports = __webpack_public_path__ + "img/yml.01c3ddab.png";